export interface Storm {
  id: number;
  name: string;
  startTime: Date;
  endTime: Date;
  statusTrack: StormDataStatus;
  trackErrorMessage: string;
  statusLocation: StormDataStatus;
  locationErrorMessage: string;
}

export interface StormInfo extends Storm {
  startUnix: number;
  endUnix: number;
  durationInSeconds: number;
}

export function toStormInfo(storm: Storm): StormInfo {
  const startUnix = Math.round(new Date(storm.startTime).valueOf() / 1000);
  const endUnix = Math.round(new Date(storm.endTime).valueOf() / 1000);

  return {
    ...storm,
    startUnix,
    endUnix,
    durationInSeconds: endUnix - startUnix,
  };
}

export class StormShift {
  id: number;
  vehicleId: number;
  vehicleName: string;
  start: number;
  end: number;
  distanceDriven?: number;
  distancePlowed?: number;
  distanceSpreadGranular?: number;
  distanceSpreadLiquid?: number;
  distanceMowed?: number;
  distanceSwept?: number;
  materialUsedGranular?: number;
  materialUsedLiquid?: number;
}

export class StormCreateRequest {
  name: string;
  startTime: string;
  endTime: string;
}

export enum StormDataStatus {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}
